export const SITE = {
  name: "Hotel Federasol",
  tagline: "Un lugar para descansar y disfrutar",
  whatsappNumber: "543456601035",
  whatsappDisplay: "+54 3456 601035",
  phoneDisplay: "+54 11 4166-3609",
  phoneHref: "tel:+541141663609",
  email: "termasfederasol@hotmail.com",
  emailHref: "mailto:termasfederasol@hotmail.com",
  address: "D'Angelo 475, Federación, Entre Ríos, Argentina",
  social: {
    instagram: "https://www.instagram.com/hotel_federasol?obrf=YjBqMTBlMWZjcWF1",
    facebook: "https://www.facebook.com/share/1CFgk2LhCB/?mibextid=wwXIfr",
  },
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

const px = (id, w = 1600) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const un = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  hero: "/hotel/ingreso.jpg",
  thermal: "/termas/termas-puente.jpg",
};

export const ATTRACTION_REAL = [true, true, true, false, false, false];

export const GOOGLE_REVIEWS = [
  { quote: "Está super bien ubicado, está cerca de todo, buenos precios, atención excelente", date: "2026-02-24" },
  { quote: "Exelente, pasamos una noche en el hotel y la chica re buena onda, desayuno temprano, re cómodo y precioso el lugar", date: "2025-11-30" },
  { quote: "Hermoso hotel. La atención muy buena!", date: "2025-11-16" },
  { quote: "Muy lindo, limpio, la atención bárbara. El personal impecable. Bien el desayuno.", date: "2025-08-17" },
];

export const GOOGLE_REVIEWS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Hotel Federasol, D'Angelo 475, Federación, Entre Ríos")}`;

export const ROOM_IMAGES = [
  "/habitaciones/doble-individual.jpg",
  "/habitaciones/doble-matrimonial.jpg",
  "/habitaciones/triple.jpg",
  "/habitaciones/familiar.jpg",
  "/habitaciones/cuadruple.jpg",
  "/habitaciones/quintuple.jpg",
];

export const GALLERY_IMAGES = [
  { src: "/hotel/fachada.jpg", real: true },
  { src: "/hotel/patio.jpg", real: true },
  { src: "/hotel/desayuno.jpg", real: true },
  { src: "/federacion/federacion-honguito.jpg", real: true },
  { src: "/hotel/pasillos.jpg", real: true },
  { src: "/termas/termas-palmera.jpg", real: true },
];

export const ATTRACTION_IMAGES = [
  "/termas/termas-aerea.jpg",
  "/termas/termas-toboganes.jpg",
  "/federacion/federacion-letrero.jpg",
];

export const NAV_HREFS = [
  { href: "#inicio", key: "inicio" },
  { href: "#habitaciones", key: "habitaciones" },
  { href: "#servicios", key: "servicios" },
  { href: "#galeria", key: "galeria" },
  { href: "#federacion", key: "federacion" },
  { href: "#ubicacion", key: "ubicacion" },
  { href: "#contacto", key: "contacto" },
];

export const scrollToSection = (e, href) => {
  if (e) e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76, duration: 1.3 });
  else el.scrollIntoView({ behavior: "smooth" });
};
